import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles(theme => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: "none",
  },
}));

export default function UploadButton(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <input
        accept=".pdf,.msg,application/vnd.ms-outlook"
        className={classes.input}
        id="contained-button-file"
        multiple
        type="file"
        onChange={props.handleChange}
        disabled={props.disabled}
      />
      <label htmlFor="contained-button-file">
        <Button {...props} component="span">
          Upload
        </Button>
      </label>
    </div>
  );
}
